
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "32px",
    "height": "32px",
    "viewBox": "0 0 32 32",
    "enable-background": "new 0 0 32 32",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "currentColor",
        "width": "32",
        "height": "32"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "fill": "currentColor",
        "d": "M26.931,15.323l-2.579,2.627c-0.213,0.207-0.557,0.207-0.77,0\n\tl-2.564-2.627c-0.305-0.36-0.101-0.489,0.112-0.698h2.347c-0.648-3.543-3.727-6.229-7.435-6.229c-2.866,0-5.36,1.605-6.643,3.971\n\tl-1.282-0.515c1.494-2.876,4.479-4.842,7.925-4.842c4.469,0,8.161,3.304,8.824,7.615h1.952\n\tC27.033,14.834,27.143,15.115,26.931,15.323z M8.532,14.764l2.58,2.628c0.212,0.208,0.102,0.487-0.11,0.696H8.767\n\tc0.897,3.194,3.813,5.539,7.275,5.539c2.636,0,4.953-1.359,6.308-3.416l1.293,0.521c-1.575,2.564-4.385,4.277-7.601,4.277\n\tc-4.226,0-7.751-2.956-8.683-6.922H5.311c-0.212-0.209-0.416-0.338-0.11-0.696l2.563-2.628C7.976,14.556,8.32,14.556,8.532,14.764z"
      }
    }
  ]
})
    }
  